import { DISPATCH_REQUESTED } from '@rsos/constants/alertStatuses';
import {
  selectCapstoneAudioSettingsForFeature,
  selectUserAudioSettingsForFeature,
} from '@rsos/sinatra/src/selectors/selectAudioSettings';
import { playTone } from './audioHelpers';
import {
  AudioNotificationsGlobalState,
  AudioNotificationStatus,
} from './audioNotificationTypes';

export async function playAlertNotificationIfNecessary(
  state: AudioNotificationsGlobalState,
  alertID: string,
  repeater: () => void,
) {
  const alert = state.incidents.alerts[alertID];
  const status: AudioNotificationStatus = {
    repeatsRemaining: 0,
    expiration: alert.sla_expiration_time,
  };

  const orgSettings = selectCapstoneAudioSettingsForFeature('alerts')(state);
  const userSettings = selectUserAudioSettingsForFeature('alerts')(state);

  // If repeat sounds is turned on, there's no limit to how many times we'll
  // repeat before the expiration.
  if (orgSettings.repeat && !alert.supplemental_only) {
    status.repeatsRemaining = Infinity;
  }

  // If the sound is turned off, mark it notified
  if (!orgSettings.sound_on || alert.status.name !== DISPATCH_REQUESTED) {
    return status;
  }

  await playTone(orgSettings.tone, userSettings.volume, repeater);

  return status;
}
